import { render, staticRenderFns } from "./revenue-detail.vue?vue&type=template&id=b94776f0&scoped=true&"
import script from "./revenue-detail.vue?vue&type=script&lang=js&"
export * from "./revenue-detail.vue?vue&type=script&lang=js&"
import style0 from "./revenue-detail.vue?vue&type=style&index=0&id=b94776f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94776f0",
  null
  
)

export default component.exports